// Blendshape (morph target) helpers shared by the viewer, lightbox and admin editor.

export function prettyName(key) {
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_.\-:]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase()) || key;
}

// Unique morph target names across every mesh, in first-seen (file) order.
export function collectMorphNames(scene) {
  const names = [];
  const seen = new Set();
  scene.traverse((obj) => {
    if (!obj.isMesh || !obj.morphTargetDictionary) return;
    Object.entries(obj.morphTargetDictionary)
      .sort((a, b) => a[1] - b[1])
      .forEach(([name]) => { if (!seen.has(name)) { seen.add(name); names.push(name); } });
  });
  return names;
}

// Saved admin settings (in their order) for names still in the file, then any new names.
export function mergeExpressions(saved = [], detected = []) {
  const inFile = new Set(detected);
  const kept = saved.filter((s) => inFile.has(s.key)).map((s) => ({ key: s.key, label: s.label || prettyName(s.key), hidden: !!s.hidden }));
  const known = new Set(kept.map((k) => k.key));
  const added = detected.filter((n) => !known.has(n)).map((n) => ({ key: n, label: prettyName(n), hidden: false }));
  return [...kept, ...added];
}
